import GloLayout from 'code-micro/common/GloLayoutA';
import { ContentServerProps } from 'code-micro/props/content';
import EcoLink from 'eco-design/base/eco-link';
import IndexClient from './index.client';
import './index.scss';

export default function Content({ id, data = {} }: ContentServerProps) {
    const prefixCls = 'index-kol-nl';
    const { title, titleColor, bgColor, list } = data;

    return (
        <GloLayout
            className={`editor-${prefixCls} editor-${prefixCls}-${id}`}
            id={id}
            data={data}
            floorName={`${prefixCls}`}
            style={
                {
                    '--title-color': titleColor,
                    '--bg-color': bgColor,
                } as React.CSSProperties
            }
        >
            <div className={`${prefixCls}-wrapper`}>
                <h2 className={`${prefixCls}-header-title`}>{title}</h2>
                <IndexClient list={list} prefixCls={prefixCls} id={id} />
            </div>
        </GloLayout>
    );
}
